import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/feature/SectionHeading';
import { journeyMilestones } from '@/mocks/aboutData';

export default function AboutJourney() {
  return (
    <section className="w-full bg-primary-950 py-14 md:py-20 relative overflow-hidden">
      <div className="pointer-events-none absolute top-0 left-1/2 w-96 h-96 -translate-x-1/2 rounded-full bg-primary-800/40 blur-3xl"></div>

      <div className="relative w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="Our Journey"
          title="Milestones That Shaped Us"
          description="From a single conviction in Madurai to a pan-India Ayurvedic brand trusted by hundreds of partners."
          tone="dark"
        />

        <div className="relative mt-12 md:mt-16">
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-primary-700/60 md:-translate-x-1/2"></div>

          <div className="space-y-8 md:space-y-12">
            {journeyMilestones.map((item, index) => {
              const isRight = index % 2 === 1;
              return (
                <Reveal key={item.id} delay={(index % 2) * 80}>
                  <div className="relative pl-12 md:pl-0 md:grid md:grid-cols-2 md:gap-10">
                    <div className={isRight ? 'md:order-2 md:pl-10' : 'md:text-right md:pr-10'}>
                      <div className="inline-block w-full rounded-lg border border-primary-700/50 bg-primary-900/70 p-5 md:p-6">
                        <span className="inline-flex items-center justify-center px-3 py-1 rounded-full bg-accent-500 text-primary-950 text-xs font-bold">
                          {item.year}
                        </span>
                        <h3 className="font-heading mt-3 text-lg font-semibold text-background-50">{item.title}</h3>
                        <p className="mt-2 text-sm leading-relaxed text-background-100/80">{item.description}</p>
                      </div>
                    </div>

                    <span className="absolute left-4 md:left-1/2 top-6 w-4 h-4 rounded-full bg-accent-400 ring-4 ring-primary-950 md:-translate-x-1/2"></span>
                    <div className={isRight ? 'hidden md:block md:order-1' : 'hidden md:block md:pl-10'}></div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}